module.exports = __webpack_public_path__ + "img/8_48.193ff4e1.png";